import { axiosInstance } from '.';

export const getMyBookings = async (): Promise<any> => {
  const { data: res } = await axiosInstance.get('/v1/self/booking/fetch-all');
  return res.data.bookings;
};

export const cancelMyBooking = async (
  transactionId: string,
): Promise<boolean> => {
  const { data: res } = await axiosInstance.post(`/v1/self/booking/cancel`, {
    transaction_id: transactionId,
  });
  return !!res.data;
};
